import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as InviteActions from '../actions/invite.actions';
import { Invite } from '@fc-core';

export const invitesFeatureKey = 'invites';

export interface State extends EntityState<Invite> {
  count: number;
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<Invite> = createEntityAdapter<Invite>();

export const initialState: State = adapter.getInitialState({
  count: 0,
  loading: false,
  error: null,
});

export const reducer = createReducer(
  initialState,
  on(
    InviteActions.loadInvites,
    // InviteActions.convertInviteToUser,
    InviteActions.resendInvite,
    InviteActions.deleteInvite,
    InviteActions.addInvite,
    (state) => ({
      ...state,
      loading: true,
    }),
  ),
  on(InviteActions.invitesError, (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
  })),
  on(InviteActions.resendInviteSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(InviteActions.loadInvitesSuccess, (state, action) => ({
    ...adapter.addMany(action.invites, state),
    loading: false,
    count: action.count,
  })),

  on(InviteActions.addInviteSuccess, (state, action) => ({
    ...adapter.addOne(action.invite, state),
    loading: false,
    count: state.count + 1,
  })),
  on(InviteActions.deleteInviteSuccess, (state, action) => ({
    ...adapter.removeOne(action.inviteId, state),
    loading: false,
    count: state.count - 1,
  })),
  // on(InviteActions.convertInviteToUserSuccess, (state, action) => ({
  //   ...adapter.removeOne(action.inviteId, state),
  //   loading: false,
  //   count: state.count - 1,
  // })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const getInvitesLoading = (state: State) => state.loading;
export const getInvitesError = (state: State) => state.error;
